import "./styles/reset.css";
import "./styles/index.css";
import "react-toastify/dist/ReactToastify.css";

// Material
import { CssBaseline } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer, Slide } from "react-toastify";
// Say
import { Provider as SayProvider } from "@asayinc/component-library";

import { App } from "./App";
import { store } from "./store/store";
import { MaintenanceMode } from "./components/organisms/MaintenanceMode";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (window.config.REACT_APP_MAINTENANCE_MODE === "true") {
  root.render(<MaintenanceMode />);
} else {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <SayProvider>
          <CssBaseline />
          <ToastContainer transition={Slide} />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </SayProvider>
      </Provider>
    </React.StrictMode>
  );
}
